import { inject, Injectable } from '@angular/core';
import { FormGroup, NonNullableFormBuilder, Validators } from '@angular/forms';

import { Recommendation } from 'src/app/models/recommendation/recommendation';
import { UserService } from 'src/app/services/user.service';

@Injectable({
  providedIn: 'root'
})
export class RecommendationFactory {
  formBuilder = inject(NonNullableFormBuilder);
  userService = inject(UserService);

  build(assesmentEditable: boolean, auditorEditable: boolean, item?: Recommendation): FormGroup {
    const currentDate = new Date();
    const formGroup = this.formBuilder.group({
      auditId: [item?.auditId ?? ''],
      auditDefinition: [item?.auditDefinition ?? ''],
      recommendationTitle: [item?.recommendationTitle ?? ''],
      title: [{ value: item?.title ?? '', disabled: !auditorEditable }, [Validators.required]],
      isSpecialAudit: [{ value: item?.isSpecialAudit ?? false, disabled: true }],
      plant: [item?.plant ?? ''],
      recommendationId: [{ value: item?.recommendationId ?? '', disabled: true }],
      priority: [{ value: item?.priority ?? 0, disabled: !auditorEditable }],
      currentDeadlineDate: [{ value: item?.currentDeadlineDate ?? null, disabled: true }],
      status: [{ value: item?.status ?? '', disabled: !(assesmentEditable || auditorEditable) }],
      shortRemarkToAssessor: [{ value: item?.shortRemarkToAssessor ?? '', disabled: true }],
      assessmentCoordinator: [{ value: item?.assessmentCoordinator ?? '', disabled: true }],
      commentExecution: [{ value: item?.commentExecution ?? '', disabled: !auditorEditable }],
      amountCapex: [{ value: item?.amountCapex ?? 0, disabled: !(assesmentEditable || auditorEditable) }],
      settledDate: [{ value: item?.settledDate ?? '', disabled: true }],
      settledBy: [item?.settledBy ?? ''],
      settledByName: [item?.settledByName ?? ''],
      settledDateFinally: [{ value: item?.settledDateFinally ?? '', disabled: true }],
      settledByFinally: [item?.settledByFinally ?? ''],
      settledByFinallyName: [item?.settledByFinallyName ?? ''],
      shortText1: [{ value: item?.shortText1 ?? '', disabled: !auditorEditable }],
      shortText2: [{ value: item?.shortText2 ?? '', disabled: !(assesmentEditable || auditorEditable) }],
      adjournedReason: [{ value: item?.adjournedReason ?? '', disabled: !(assesmentEditable || auditorEditable) }],
      adjournedDate: [item?.adjournedDate ?? ''],
      adjournedBy: [item?.adjournedBy ?? ''],
      adjournedByName: [item?.adjournedByName ?? ''],
      sequenceNumber1: [
        { value: item?.sequenceNumber1 ?? 0, disabled: !auditorEditable },
        [Validators.pattern('^[0-9]*$'), Validators.required]
      ],
      sequenceNumber2: [
        { value: item?.sequenceNumber2 ?? 0, disabled: !auditorEditable },
        [Validators.pattern('^[0-9]*$'), Validators.required]
      ],
      reportTypeDAFC: [item?.reportTypeDAFC ?? ''],
      isLegallyRequired: [{ value: item?.isLegallyRequired ?? false, disabled: !auditorEditable }],
      budget: [
        { value: item?.budget ?? '', disabled: !(assesmentEditable || auditorEditable) },
        [Validators.pattern('^[0-9]*$')]
      ],
      initialDeadline: [{ value: item?.initialDeadline ?? '', disabled: !auditorEditable }, [Validators.required]],
      plantComments: [{ value: item?.plantComments ?? '', disabled: !assesmentEditable }],
      category: [{ value: item?.category ?? '', disabled: !auditorEditable }, [Validators.required]],
      concernsName: [{ value: item?.concernsName ?? '', disabled: true }],
      concernsCountry: [{ value: item?.concernsCountry ?? '', disabled: true }],
      reportingYear: [{ value: item?.reportingYear ?? '', disabled: true }],
      legalUnit: [{ value: item?.legalUnit ?? '', disabled: true }],
      department: [{ value: item?.department ?? '', disabled: true }],
      auditor: [{ value: item?.auditor ?? '', disabled: true }],
      assessmentCoordinatorName: [item?.assessmentCoordinatorName ?? ''],
      legalUnitResponsibles: [{ value: item?.legalUnitResponsibles ?? [], disabled: true }],
      legalUnitResponsiblesNames: [item?.legalUnitResponsiblesNames ?? []],
      emailAddress: [{ value: item?.emailAddress ?? '', disabled: true }],
      modificationAction: [item?.modificationAction ?? []],
      modificationDate: [item?.modificationDate ?? []],
      modificationStatus: [item?.modificationStatus ?? []],
      fileLinkId: [item?.fileLinkId ?? ''],
      settledRejectReason: [{ value: item?.settledRejectReason ?? '', disabled: !auditorEditable }],
      otherResponsiblesNames: [item?.otherResponsiblesNames ?? []],
      otherResponsibles: [item?.otherResponsibles ?? []],
      prolongationDecision: [{ value: item?.prolongationDecision ?? '', disabled: !auditorEditable }],
      prolongationStatus: [item?.prolongationStatus ?? ''],
      prolongationHistory: [item?.prolongationHistory ?? []],
      prolongationDeadline: [{ value: item?.prolongationDeadline ?? '', disabled: !auditorEditable }],
      prolongationRequestDate: [item?.prolongationRequestDate ?? ''],
      prolongationRequestBy: [item?.prolongationRequestBy ?? ''],
      prolongationRequestByName: [item?.prolongationRequestByName ?? ''],
      prolongationGrantedDate: [item?.prolongationGrantedDate ?? ''],
      prolongationGrantedBy: [item?.prolongationGrantedBy ?? ''],
      prolongationGrantedByName: [item?.prolongationGrantedByName ?? ''],
      prolongation: [item?.prolongation ?? ''],
      prolongationOtherDate: [{ value: item?.prolongationOtherDate ?? '', disabled: true }],
      prolongationOtherHistory: [{ value: item?.prolongationOtherHistory ?? '', disabled: true }],
      prolongationToAssessor: [{ value: item?.prolongationToAssessor ?? '', disabled: !auditorEditable }],
      responsibleAssessment: [item?.responsibleAssessment ?? ''],
      responsibleAssessmentName: [item?.responsibleAssessmentName ?? ''],
      responsibleAssessmentAzureId: [item?.responsibleAssessmentAzureId ?? ''],
      legalUnitResponsiblesCc: [item?.legalUnitResponsiblesCc ?? []],
      legalUnitResponsiblesCcNames: [item?.legalUnitResponsiblesCcNames ?? []],
      legalUnitResponsiblesCcAzureIds: [item?.legalUnitResponsiblesCcAzureIds ?? []],
      readOthersLegalUnit: [item?.readOthersLegalUnit ?? []],
      readOthersLegalUnitNames: [item?.readOthersLegalUnitNames ?? []],
      readOthersLegalUnitAzureIds: [item?.readOthersLegalUnitAzureIds ?? []],
      sendReminder0Days: [item?.sendReminder0Days ?? false],
      sendReminder12Month: [item?.sendReminder12Month ?? false],
      sendReminder14Days: [item?.sendReminder14Days ?? false],
      sendReminder30DaysBefore: [item?.sendReminder30DaysBefore ?? false],
      sendReminder1Month: [item?.sendReminder1Month ?? false],
      sendReminder3Month: [item?.sendReminder3Month ?? false],
      sendReminderAll3Months: [item?.sendReminderAll3Months ?? 0],
      authorsAuditor: [item?.authorsAuditor ?? ''],
      authorsBinGen: [item?.authorsBinGen ?? ''],
      authorsRec: [item?.authorsRec ?? ''],
      keypersons: [item?.keypersons ?? []],
      myAttention: [item?.myAttention ?? []],
      readersBusinessGroup: [item?.readersBusinessGroup ?? ''],
      readersLegalUnit: [item?.readersLegalUnit ?? ''],
      readersResponsible: [item?.readersResponsible ?? []],
      decision: [item?.decision ?? ''],
      createdByUserId: [item?.createdByUserId ?? ''],
      id: [item?.id ?? ''],
      createdAt: [item?.createdAt ?? currentDate],
      modifiedAt: [item?.modifiedAt ?? ''],
      createdBy: [item?.createdBy ?? this.userService.userProfile().id],
      modifiedBy: [item?.modifiedBy ?? ''],
      createdTick: [item?.createdTick ?? 0],
      modifiedTick: [item?.modifiedTick ?? 0],
      newDeadline: ['']
    });
    return formGroup;
  }
}
